export const TEMPLATES_OVERVIEW_QUERY = `
query TemplateOverview { 
\ttemplates { 
  \tid
    name
    createdAt
  }
}
`